<template>
    <div>
        
    </div>
</template>
<script>
import {setCookie,getCookie} from '../../assets/js/cookie.js'
export default {
    data(){
        return{
            
        }
    },
    mounted(){
        this.token = this.$route.query.token;
        this.getDate();
    },
    methods:{
        getDate(){
            let token = this.$route.query.token == undefined ? '' : this.$route.query.token;
            if(token == '')
            {
                location.href = '//www.cnsaas.com/SSOLogin.aspx';
            }
            else
            {
                let that = this;
                let data = { 'fyzxtoken': token}
                this.$ajax({
                    method: 'post',
                    url: this.GLOBAL.serverSrc + '/login/fyzxsmslogin.json',
                    data: data,
                    headers: {
                        'Content-Type': 'application/json; charset=UTF-8'
                    }
                }).then(function(res) {
                    if('0000000' == res.data.code)
                    {
                        that.GLOBAL.token = res.data.token;
                        setCookie('2officesessionid',res.data.token,60*60*10);
                        location.href = '/main';
                    }
                    else if("0000012" == res.data.code)
                    {
                        location.href = '//www.cnsaas.com/SSOLogin.aspx';
                    }
                    else
                    {
                        alert(res.data.msg);
                    }
                })
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/fyzxlogin/fyzx_login.vue